// Backend
import React from 'react';

// Frontend
import { Grid, Cell } from 'react-foundation';
import '../../stylesheets/components/Pages.css';

// Functionality
import { useLocation } from 'react-router-dom';

// Components
import { Header, FlashMessage } from '../../constants/SharedComponents';
import useCurrentUser from '../../hooks/useCurrentUser';

export function PagesAboutFwd() {
  // API
  const currentUser = useCurrentUser();
  const { state } = useLocation();

  // Objects
  const [flashMessageObject, setFlashMessageObject] = React.useState({});

  // @see https://css-tricks.com/run-useeffect-only-once/#
  // The second param will ensure the useEffect only runs once.
  // eslint-disable-next-line
  React.useEffect(() => {
    if (state && state.hasOwnProperty('flash')) {
      setFlashMessageObject(state.flash);
    }
  }, [currentUser, state]);

  return (
    <>
      <Header />
      <FlashMessage object={flashMessageObject} columnWrap={true} />

      <div className="grid-container">
        <Grid className="grid-padding-x align-justify">
          <Cell small={12}>
            <div className="page-content">
              <h1 className="page-content__title">What is Forward Together</h1>
              <div className="page-content__styles">
                <p>Work-related stress is one of the biggest threats to UK workplaces, costing each year billions of pounds to UK employers due 
                  to sickness absence and high turnover. But even when someone is present at work, they may still be struggling. 
                  Forward Together was designed to support those people facing challenges in their work and address any risks to mental health before 
                  the risks impact the individual, their colleagues and the organisation. Forward Together is an easy-to-use tool designed to help managers 
                  and their team members to spot risks early and develop solutions together. 
                </p>
              </div>

            </div>          
            </Cell>
          
          <Cell small={12} large={6}>
            <div className="page-content">
              <div className="page-content__styles">
                <h2 className="page-content__title">Who should use this tool</h2>
                <p>
                  The tool can be used by any line manager and team member, preferably in a proactive and preventative way, aiming to address the challenges 
                  before they become an issue. The tool can be used to support regular one-to-ones or ad hoc if either the manager or the team member has a 
                  concern for the team member’s wellbeing.{' '}
                </p>
                <h2 className="page-content__title">Academic Foundations</h2>
                <p>
                  The tool emerged as a collaboration between the Centre for Human Factors (University of Hull) and the four local authorities in our Humber region. 
                  Through this collaboration, we identified the need for tools and guidance for managers to support their team members more effectively. Forward Together 
                  has been guided by the work and expertise of the Director of the Centre for Human Factors, Prof. Fiona Earle. Fiona specialises in working with 
                  organisations to understand the unique sources of stress facing their workforce and help them proactively manage employee wellbeing. Building on the 
                  expertise of the team at the Centre for Human Factors, the tool benefits from practical insight, psychology research, and established frameworks such 
                  as HSE’s Management Standards.                
                </p>
                <p>
                  At the cornerstone of Forward Together is a risk-based approach, employing traditional methods of risk assessment to support healthier work. 
                  This is a well-established approach to managing traditional ‘health & safety’, by identifying the risks, understanding the impacts and then 
                  proposing controls to reduce the risk. However, despite this being the HSE’s recommended approach for managing work-related stress, and the 
                  growing evidence-base of the benefits of this approach, risk assessments for mental health are much less common. 
                </p>
                <p>
                  Forward Together provides a structured process benefiting from solid academic foundations for an individual stress risk assessment. 
                </p>
              </div>
            </div>
          </Cell>
          
          <Cell small={12} large={6}>
            <div className="page-content">
			        <h4>Watch Fiona Explain the background to the Forward Together Tool</h4>
              <div className="page-content__styles">
                <iframe
                  className="sproutvideo-player"
                  src="https://videos.sproutvideo.com/embed/a79fd8b91019e7c12e/b61cf852c6491138"
                  width="640"
                  height="363"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Video Player"
                  style={{width: '100%', maxWidth: '640px'}}
                ></iframe>
              </div>
          </div>
          </Cell>
          
          <Cell small={12}>
            <div className="page-content">
              <div className="page-content__styles">
                <h2 className="page-content__title">More Information</h2>
                <p>
                  Forward Together was funded by the DLUHC Local Digital Fund, as part of a series of projects led by 
                  East Riding Yorkshire Council in collaboration with Hull City Council, 
                  North East Lincolnshire Council and North Lincolnshire Council.
                </p>
              </div>
            </div>
          </Cell>
        </Grid>
      </div>
    </>
  );
}
